<template>
  <hic-list-page title="应用管理" :entities="entities" :condition="condition" @load="page" :loading="searchLoading" hide-footer>
    <template slot="buttons">
      <el-button @click.native="create" type="primary" size="small" v-if="permission.masterdata_sys_create"> <i class="el-icon-plus"></i> 新建 </el-button>
    </template>
        <el-table-column v-if="permission.masterdata_sys_edit || permission.masterdata_sys_delete" fixed="left" label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button v-if="permission.masterdata_sys_edit" size="mini" type="primary" icon="el-icon-edit" circle plain @click="handleEdit(scope.row)" style="margin-right: 8px"></el-button>
            <el-popconfirm v-if="permission.masterdata_sys_delete" confirmButtonText="确认" cancelButtonText="取消" icon="el-icon-info" iconColor="red" title="确认删除这条应用？" @confirm="handleDelete(scope.row)">
              <el-button size="mini" type="danger" icon="el-icon-delete" circle plain slot="reference"></el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
        <el-table-column fixed="left" prop="name" label="应用名称" width="200" sortable="custom">
          <template slot-scope="{ row }">
            <b>{{ row.name }}</b>
          </template>
        </el-table-column>
        <el-table-column prop="code" label="编码" width="100" sortable="custom"></el-table-column>
        <el-table-column prop="name" label="图标" width="80">
          <template slot-scope="{ row }">
            <el-image v-if="row.logoUri" :src="$cfg.oauth.server + '/' + row.logoUri" style="width: 50px; height: 50px"/>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="securityCode" label="安全码" width="120"></el-table-column> -->
        <el-table-column prop="homeUrl" show-overflow-tooltip label="首页地址" width="240"></el-table-column>
        <el-table-column prop="seq" label="排序" width="80" sortable="custom"></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
    <apply-editor v-model="entity" :visible.sync="showEditor" @ok="page" />
  </hic-list-page>
</template>

<script>
import api from "./api.js";
import store from "@/common/store";
import { mapGetters } from "sw-hic";
export default {
  beforeRouteEnter(to, from, next) {
    // 在渲染该组件的对应路由被 confirm 前调用
    // 不！能！获取组件实例 `this`
    // 因为当守卫执行前，组件实例还没被创建
    if (!store.getters.permission.masterdata_sys_query) {
      next({
        name: "err",
        params: { err: cfg.errs.NeedPromission },
      });
    } else {
      next();
    }
  },
  components: {
    "apply-editor": () => import("./editor"),
  },
  data() {
    return {
      entity: {},
      entities: {},
      condition: {
        sort: "seq",
        asc: true,
        keyword: null,
        pageIndexOnView: 1,
      },
      searchLoading: false,
      showEditor: false,
      disabledSave: false,
      //区分是否编辑状态 // 'true==>应用新增false==>应用编辑'
      between: null,
    };
  },
  computed: {
    ...mapGetters(["permission"]),
  },
  methods: {
    handleDelete(val) {
      if (val.id) {
        let _this = this;
        api.Apply.del(val.id).then((res) => {
          _this.page();
          _this.$message.success("删除成功!");
        });
      }
    },
    handleEdit(val) {
      this.entity = JSON.parse(JSON.stringify(val));
      this.showEditor = true;
    },
    create() {
      this.entity = {};
      this.showEditor = true;
    },
    page() {
      let _this = this;
      this.searchLoading = true;
      api
        .Apply.query(this.condition)
        .then((res) => {
          _this.entities = res;
        })
        .catch((err) => {
          if (err) {
            _this.$message.error(err.message || err);
          }
        })
        .finally(() => {
          _this.searchLoading = false;
        });
    },
    sortChanged(col) {
      if (!col.order) {
        this.condition.sort = "id";
        this.condition.asc = false;
      } else {
        this.condition.sort = col.prop;
        this.condition.asc = col.order == "ascending";
      }
      this.page();
    },
    filterChanged(options) {
      Object.assign(this.condition, options);
      this.page();
    },
  },
};
</script>
